import {Comparateurs} from './ComparateurCritère.js';


export class Cible {

    static comparateursParDéfaut = [Comparateurs.ÉGALE, Comparateurs.EST_PARMI, Comparateurs.EST_DIFFÉRENT, Comparateurs.N_EST_PAS_PARMI];

    code;
    nom;
    description = "";
    comparateurs = Cible.comparateursParDéfaut;
    valeursPossibles = new Map();

    constructor(code, nom, description, comparateurs, valeursPossibles) {
        this.code = code;
        this.nom = nom;
        this.description = description || "";
        this.comparateurs = comparateurs || Cible.comparateursParDéfaut;
        this.valeursPossibles = valeursPossibles || new Map();
    }

}
